import React from "react";
import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

const OFFER = [
  {
    n: "01",
    title: "Nagrobki",
    img: "https://images.pexels.com/photos/6841641/pexels-photo-6841641.jpeg?auto=compress&cs=tinysrgb&w=1400",
    items: [
      "Nagrobki pojedyncze, podwójne, rodzinne",
      "Grobowce i nagrobki urnowe",
      "Renowacja i modernizacja nagrobków",
      "Akcesoria nagrobne — ławki, wazony, lampiony",
    ],
    span: "lg:col-span-7 lg:row-span-2",
  },
  {
    n: "02",
    title: "Liternictwo i grawerowanie",
    img: "https://images.unsplash.com/photo-1606326608690-4e0281b1e588?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      "Litery kute i piaskowane",
      "Grawerowanie napisów",
      "Portrety i zdjęcia na porcelanie",
      "Złocenie i srebrzenie liter",
      "Renowacja napisów",
    ],
    span: "lg:col-span-5",
  },
  {
    n: "03",
    title: "Parapety kamienne",
    img: "https://images.unsplash.com/photo-1615876234886-fd9a39fda97f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      "Parapety wewnętrzne i zewnętrzne",
      "Pomiar i montaż",
      "Realizacje na wymiar",
    ],
    span: "lg:col-span-5",
  },
  {
    n: "04",
    title: "Schody kamienne",
    img: "https://images.unsplash.com/photo-1529160638848-c6c71fee1cb7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    items: [
      "Schody wewnętrzne i zewnętrzne",
      "Stopnie granitowe",
      "Podesty i cokoły",
      "Balustrady (we współpracy z partnerami)",
    ],
    span: "lg:col-span-7",
  },
  {
    n: "05",
    title: "Blaty kamienne",
    img: "https://images.unsplash.com/photo-1682888813913-e13f18692019?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    items: [
      "Blaty kuchenne i łazienkowe",
      "Wyspy kuchenne",
      "Blaty do lokali usługowych",
    ],
    span: "lg:col-span-7",
  },
  {
    n: "06",
    title: "Elementy architektury",
    img: "https://images.unsplash.com/photo-1505691938895-1758d7feb511?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    items: [
      "Kominki, ościeżnice, obudowy słupów",
      "Posadzki kamienne",
      "Tarasy granitowe",
      "Elewacje z kamienia naturalnego",
    ],
    span: "lg:col-span-5",
  },
];

export default function Offer({ onOpenQuote }) {
  return (
    <section id="oferta" data-testid="offer-section" className="relative py-24 md:py-36 bg-[#080808]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <Reveal className="lg:col-span-7">
            <p className="overline mb-6">Oferta</p>
            <h2 className="section-title text-white text-4xl md:text-6xl leading-[1.04]">
              Sześć kierunków,
              <br />
              <span className="italic text-neutral-300">jeden materiał</span> — kamień.
            </h2>
          </Reveal>
          <Reveal delay={150} className="lg:col-span-5 lg:pt-6">
            <p className="text-neutral-400 leading-relaxed">
              Od subtelnej, ręcznej obróbki liter, po wielkogabarytowe blaty kuchenne i tarasy z
              granitu — łączymy całą paletę usług w jednym warsztacie, pod jednym, rzetelnym
              nadzorem.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-neutral-900">
          {OFFER.map((o, i) => (
            <Reveal key={o.n} delay={i * 80} className={`bg-[#080808] ${o.span} group`}>
              <div className="relative h-full p-7 md:p-10 flex flex-col min-h-[420px]">
                <div className="absolute inset-0">
                  <img
                    src={o.img}
                    alt={o.title}
                    className="w-full h-full object-cover opacity-[0.18] group-hover:opacity-30 transition-opacity duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#080808] via-[#080808]/85 to-transparent" />
                </div>

                <div className="relative flex items-start justify-between mb-8">
                  <span className="font-serif-display text-white/30 text-xl">{o.n}</span>
                  <ArrowUpRight
                    size={18}
                    strokeWidth={1}
                    className="text-white/30 group-hover:text-white group-hover:rotate-45 transition-all duration-500"
                  />
                </div>

                <h3 className="relative font-serif-display text-white text-3xl md:text-4xl leading-tight mb-6">
                  {o.title}
                </h3>

                <ul className="relative space-y-2.5 mt-auto">
                  {o.items.map((it, k) => (
                    <li
                      key={k}
                      data-testid={`offer-${o.n}-item-${k}`}
                      className="text-sm text-neutral-300 flex gap-3 items-baseline"
                    >
                      <span className="text-[var(--accent)] text-[10px]">●</span>
                      <span>{it}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-6">
          <p className="font-serif-display text-2xl md:text-3xl text-white max-w-xl leading-tight">
            <span className="italic text-neutral-400">Nie widzisz tego, czego szukasz?</span>{" "}
            Realizujemy projekty indywidualne.
          </p>
          <button
            data-testid="offer-cta-quote"
            className="btn-primary"
            onClick={onOpenQuote}
          >
            Zapytaj o wycenę
          </button>
        </div>
      </div>
    </section>
  );
}
